// extracted by mini-css-extract-plugin
export var dateLabel = "_2r-0";
export var dateLabelError = "_2r-1";
export var fullWidth = "_2r-2";
export var smaller = "_2r-3";